import { Component } from '@angular/core';

@Component({
  selector: 'uni-table-cell-content',
  templateUrl: './uni-table-cell-content.component.html',
  styleUrls: ['./uni-table-cell-content.component.scss']
})
export class UniTableCellContentComponent {}
